<template>
	<search-list :pageSizes="[25,30,40]" apiPath="/channelRule/list" :where="where" :searchKeys="searchKeys" ref="sl">
		<mm-lc title="Rule Status">
			<mm-adv-status v-model="where.status" multiple/>
		</mm-lc>
		<mm-lc title="Operator">
			<mm-users v-model="where.operator" multiple></mm-users>
		</mm-lc>
		<template slot="statusAction">
			<el-dropdown size="mini" trigger="click">
				<el-button size="small" type="primary">
					<i class="el-icon-edit"></i>Change Status
				</el-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item class="status-active" @click.native="changeStatus('active')">Switch to Active</el-dropdown-item>
					<el-dropdown-item class="status-paused" @click.native="changeStatus('paused')">Switch to Paused</el-dropdown-item>
					<el-dropdown-item class="status-pending" @click.native="changeStatus('pending')">Switch to Pending</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</template>
		<mm-table slot="dataTable" slot-scope="res" :res="res" @selection-change="selectRule">
			<el-table-column type="selection"></el-table-column>
			<el-table-column label="Channel ID" prop="channel_id" />
			<el-table-column label="Channel Name" prop="channel_name">
				<mm-get-detail slot-scope="sp" :row_name="sp.row.channel_name" :row_id="sp.row.channel_id" :row_type="'channel'"/>
			</el-table-column>
			<el-table-column label="Campaign Budget($)" prop="camp_budget" />
			<el-table-column label="Total Offers">
                <span slot-scope="sp">{{sp.row.nice_offer+'/'+sp.row.fresh_offer}}</span>
			</el-table-column>
			<el-table-column label="Rule Status" prop="status">
				<span slot-scope="sp" :class="'status-'+sp.row.status">{{sp.row.status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="Operator" prop="operator" />
			<el-table-column label="action">
				<template slot-scope="sp">
					<el-dropdown size="small" trigger="click">
						<el-button type="primary" plain size="mini">Action</el-button>
						<el-dropdown-menu slot="dropdown" >
							<el-dropdown-item @click.native="editRule(sp.row)">Edit Rule</el-dropdown-item>
							<el-dropdown-item @click.native="edit(sp.row)">Edit Channel</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>

			</el-table-column>

		</mm-table>

	</search-list>
</template>

<script>
export default {
	data() {
		const searchKeys = {
			channel_name: { label: "Channel Name", fuzzy: true },
			channel_id: { label: "Channel Id" }
		};
		return {
			searchKeys,
			where: {
                status: "",
                operator: ""
			},
			channel_arr:[],
		};
	},
	methods: {
		edit(row){
			window.open('/channelEdit?id='+row.channel_id);
		},
		editRule(row){
			window.open('/channelRuleEdit?id='+row.channel_id);
		},
		selectRule(channel_arr){
			this.channel_arr = channel_arr;
		},
		async changeStatus(status){
			if(this.channel_arr.length == 0){
				this.$message({
					type:'error',
					message:'Nothing Change'
				});
				return;
			}
			let channel_ids = [];
			for (const channel of this.channel_arr) {
				channel_ids.push([channel.channel_id]);
			}
			const result = await this.$post('/channelRule/updateAll',{status:status,channel_ids:channel_ids});
			if(result){
				this.$refs.sl.refresh();
			}
		}
	}
};
</script>

<style scoped>
.bt-create {
  position: relative;
  right: 0px;
}
</style>
